import { RmaLgmTypeCodes } from '@harvestiq/constants';
import { z, zDecimalRequired } from '@harvestiq/zod';

export const lgmSingleHeadQuoteSchema = z.object({
  salesEffectiveDate: z.string(),
  typeCode: z.nativeEnum(RmaLgmTypeCodes),
  marketingMonth: z.string(),
  deductible: z.number(),
  grossMarginGuarantee: zDecimalRequired(),
  basePremium: zDecimalRequired(),
  subsidyDollar: zDecimalRequired(),
  producerPremium: zDecimalRequired(),
});

export type LgmSingleHeadQuote = z.infer<typeof lgmSingleHeadQuoteSchema>;
